'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.betagroups.edit', [])
  .controller('BetaGroupsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betagroups/edit/index.js